import React from "react";
import { Skeleton } from "@/components/Skeleton";
import { NextToJumpSkeleton } from "@/features/racing/components/Tabs/NextToJumpSkeleton";
import { RacesByDaySkeleton } from "@/features/racing/components/RacesByDaySkeleton";

import * as styles from "./RacingSkeleton.module.scss";

const RacingSkeleton = ({ tab }: { tab: string }) => {
  return (
    <>
      <div className={styles.raceTabs}>
        <Skeleton shape="rect" className={styles.yesterday} />
        <Skeleton shape="rect" className={styles.nextToJump} />
        <Skeleton shape="rect" className={styles.today} />
        <Skeleton shape="rect" className={styles.tomorrow} />
        <Skeleton shape="circle" className={styles.calender} />
      </div>
      <div className={styles.filters}>
        <div>
          <Skeleton shape="circle" />
          <Skeleton shape="circle" />
          <Skeleton shape="circle" />
          <Skeleton shape="circle" />
        </div>
        <div>
          <Skeleton shape="circle" />
          <Skeleton shape="circle" />
        </div>
      </div>
      {tab === "/next-to-jump" ? (
        <NextToJumpSkeleton />
      ) : (
        <RacesByDaySkeleton />
      )}
    </>
  );
};

export { RacingSkeleton };
